import {baseUrl} from './CONSTANTS';
/**
 * 格式化对象为url
 */
export const formatObjToUrl = obj => {
	if(obj) {
		let arr = [];
		Object.keys(obj).map(item => arr.push(`${item}=${obj[item]}`));
		return `?${arr.join('&')}`;
	}
	return '';
};

/**
 * 验证restful数据的code
 */
export const verifyCode = res => {
	if(res && res.hasOwnProperty('code') && res.code === 200){
		return true
	}
	return false;
};

/**
 * 微信静默授权
 */
export const wxAuthBase = (url = '') => {
	location.href = `${baseUrl}/wxauth?url=${url}`;
};

/**
 * 验证手机号码
 * 随着手机号段的增多，只做是否为1开头
 * @param cellphone
 * @return
 */
export const checkMobile = mobile => {
	if(!(/^1\d{10}$/.test(mobile))){
		return false;
	}
	return true;
};


// WEBPACK FOOTER //
// ./src/config/Utility.js